import { NodeEnum, type NodeDefault } from '../../types';
import { SealNodeType } from './types';

const nodeDefault: NodeDefault<SealNodeType> = {
  author: 'PIKA',
  about: '印章抽取节点',
  icon: 'icon-video_fill_light',
  color: '#4CAF50',
  defaultData: {
    type: NodeEnum.SealExtraction,
    tableConfig: '',
    name: '印章抽取节点',
    title: '印章抽取节点',
  },

  name: '印章抽取节点',
  getAvailablePrevNodes() {
    return [];
  },
  getAvailableNextNodes() {
    return [];
  },
  checkValid() {
    return {
      isValid: true,
    };
  },
};

export default nodeDefault;
